import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum CrmOfferBillingTypeId {
  PERCENTAGE = 'percentage',
  FEE = 'fee',
  EVENTS = 'events',
}

export class CrmOfferBillingType extends Codebook<CrmOfferBillingTypeId> {
  static readonly PERCENTAGE = new CrmOfferBillingType(CrmOfferBillingTypeId.PERCENTAGE, () =>
    $t('Percentage'),
  )
  static readonly FEE = new CrmOfferBillingType(CrmOfferBillingTypeId.FEE, () => $t('Fee'))
  static readonly EVENTS = new CrmOfferBillingType(CrmOfferBillingTypeId.EVENTS, () => $t('Events'))

  private constructor(
    id: CrmOfferBillingTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
